import {makeEnvironmentProviders} from '@angular/core';
import {ApiConfiguration as AuthServerApiConfiguration} from '|api/auth-server';
import {ApiConfiguration as CodebookApiConfiguration} from '|api/codebook';
import {ApiConfiguration as ComponentApiConfiguration} from '|api/component';
import {ApiConfiguration as ConfigServerApiConfiguration} from '|api/config-server';
import {ApiConfiguration as CoreApiConfiguration} from '|api/core';
import {ApiConfiguration as DocumentApiConfiguration} from '|api/document';
import {ApiConfiguration as ElasticApiConfiguration} from '|api/elastic';
import {ApiConfiguration as FlowApiConfiguration} from '|api/flow';
import {ApiConfiguration as IncidentLogApiConfiguration} from '|api/incident-log';
import {ApiConfiguration as NotificationApiConfiguration} from '|api/notification';
import {ApiConfiguration as ErmsApiConfiguration} from '|api/erms-api';
import {ApiConfiguration as RecordsApiConfiguration} from '|api/records';
import {ApiConfiguration as SadApiConfiguration} from '|api/sad';
import {ApiConfiguration as SubjectRegisterApiConfiguration} from '|api/subject-register';
import {ApiConfiguration as TransactionLogApiConfiguration} from '|api/transactionlog';
import {ApiConfiguration as WebdavApiConfiguration} from '|api/webdav';
import {
  AUTH_MICROSERVICE_ROOT,
  CONFIG_MICROSERVICE_ROOT,
  CORE_MICROSERVICE_ROOT,
  SUBJECT_REGISTER_MICROSERVICE_ROOT
} from '|ui-essl-core';

export function provideEsslApiConfigurations() {
  return makeEnvironmentProviders([
    {
      provide: AuthServerApiConfiguration,
      useValue: {rootUrl: AUTH_MICROSERVICE_ROOT},
    },
    {
      provide: CodebookApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: ComponentApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: ConfigServerApiConfiguration,
      useValue: {rootUrl: CONFIG_MICROSERVICE_ROOT},
    },
    {
      provide: CoreApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: DocumentApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: ElasticApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: FlowApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: IncidentLogApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: NotificationApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: ErmsApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: RecordsApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: SadApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: SubjectRegisterApiConfiguration,
      useValue: {rootUrl: SUBJECT_REGISTER_MICROSERVICE_ROOT},
    },
    {
      provide: TransactionLogApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    },
    {
      provide: WebdavApiConfiguration,
      useValue: {rootUrl: CORE_MICROSERVICE_ROOT},
    }
  ]);
}
